let geoApiInstance;

class GeoApi {
  comuni;
  provinces = [];
  regions = [];
  constructor(comuni) {
    this.comuni = comuni;
    this.initRegionsAndProvinces(comuni);
  }

  initRegionsAndProvinces = comuni => {
    const regionMap = new Map();
    const provincesMap = new Map();
    for (let index = 0; index < comuni.length; index++) {
      const region = comuni[index].regione;
      const province = {
        codice: comuni[index].provincia.codice,
        sigla: comuni[index].sigla,
        nome: comuni[index].provincia.nome || comuni[index].nome,
        codRegion: region.codice
      };
      if (!regionMap.has(region.codice)) {
        regionMap.set(region.codice, true);
        this.regions.push(region);
      }

      if (!provincesMap.has(province.codice)) {
        provincesMap.set(province.codice, true);
        this.provinces.push(province);
      }
    }

    this.regions.sort((a, b) => (a.nome > b.nome ? 1 : -1));
    this.provinces.sort((a, b) => (a.nome > b.nome ? 1 : -1));
  };

  getRegions = () =>
    this.regions.map(el => ({ label: el.nome, value: el.codice }));

  getProvinces = region =>
    this.provinces
      .filter(el => el.codRegion === region)
      .map(el => ({ label: el.nome, value: el.sigla.toLowerCase() }));

  getComuni = province => {
    return this.comuni
      .filter(el => el.sigla.toLowerCase() === province.toLowerCase())
      .map(el => ({ label: el.nome, value: el.codice }));
  };

  getCap = codComune => {
    const comune = this.comuni.find(
      el => el.codice.toLowerCase() === codComune.toLowerCase()
    );
    return comune.cap.map(el => ({ label: el, value: el }));
  };

  getComuneLabel = codComune => {
    const comune = this.comuni.find(
      el => el.codice.toLowerCase() === codComune.toLowerCase()
    );

    return comune.nome;
  };

  getProvinceLabel = codProvincia => {
    const prov = this.comuni.find(
      el => el.sigla.toLowerCase() === codProvincia.toLowerCase() && el.provincia
    );
    return prov.provincia.nome
  }

  getRegioneLabel = codRegione => {
    return this.regions.find(el => el.codice === codRegione).nome;
  };
}

export const getGeoApi = comuni => {
  if (!geoApiInstance) {
    geoApiInstance = new GeoApi(comuni);
  }
  return geoApiInstance;
};
